import { axios } from '@Root/API'

export const remove = payload => {
	return axios.delete('page-setting/rule', { data: payload })
}
